//  eslint-disable
import store from "@/store";
import axios from "axios";

import config from "../config";
const baseUrlServer = config.baseApiUri;

export const axiosSingleton = (function createSingleton() {
  let instance = null;

  async function createInstance() {
    instance = axios.create({
      baseURL: baseUrlServer,
      withCredentials: false,
      headers: {
        Accept: "application/json, multipart/form-data",
        "Content-Type": "application/json; charset=utf8",
      },
    });

    instance.interceptors.response.use(
      (response) => response,
      async (error) => {
        if (error.response.status === 401) {
          console.log("Error 401 se intenta renovar el tokens ");
          store.dispatch("oidc/authenticateOidcSilent").then(() => {
            instance.defaults.headers.common[
              "Authorization"
            ] = `Bearer ${store.state.oidc.id_token}`;
            const originalRequest = error.config;

            return axios
              .request(originalRequest)
              .finally(() => location.reload());
          });
        }
        return Promise.reject(error);
      }
    );

    window.store = store.state.oidc;
    window.axiosInstance = instance;
  }

  function getInstance() {
    if (!instance) {
      this.createInstance();
    }
    return instance;
  }

  return {
    createInstance,
    getInstance,
  };
})();
